import axios from "axios";
import Cookies from "js-cookie";
import React, { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";

export const GlobalContext = createContext();

export const GlobalProvider = (props) => {
  let navigate = useNavigate();

  const [data, setData] = useState(null);

  //indikator
  const [fetchStatus, setFetchStatus] = useState(true);

  const [currentId, setCurrentId] = useState(-1);

  const { checked, setChecked } = useState(false);

  const [search, setSearch] = useState("");

  const [filter, setFilter] = useState({
    company_city: "",
    job_tenure: "",
    job_type: "",
  });

  const [input, setInput] = useState({
    title: "",
    job_description: "",
    job_qualification: "",
    job_type: "",
    job_tenure: "",
    job_status: 0,
    company_name: "",
    company_image_url: "",
    company_city: "",
    salary_min: 0,
    salary_max: 0,
  });

  const handleEdit = (event) => {
    let idData = parseInt(event.target.value);

    // console.log(idData);
    setCurrentId(idData);
    navigate(`/dashboard/list-job-vacancy/${idData}`);
  };

  const handleDetail = (event) => {
    let idData = parseInt(event.target.value);

    console.log(idData);
    setCurrentId(idData);
    navigate(`/job-vacancy/${idData}`);
  };

  const handleDelete = (event) => {
    let idData = parseInt(event.target.value);

    axios
      .delete(`https://dev-example.sanbercloud.com/api/job-vacancy/${idData}`, {
        headers: { Authorization: "Bearer " + Cookies.get("token") },
      })
      .then((res) => {
        setFetchStatus(true);
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleText = (params) => {
    if (params === null) {
      return "";
    } else {
      return params.slice(0, 30) + "...";
    }
  };

  const handleInput = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    setInput({ ...input, [name]: value });
  };

  const handleChecked = (event) => {
    let checked = event.target.checked;
    let value = event.target.value;

    if (value === 0) {
      setChecked(false);
    } else if (value === 1) {
      setChecked(true);
    }
    console.log(value);
  };
  const handleCheckbox = (event) => {
    let check = event.target.checked;

    if (check === true) {
      setInput({ ...input, job_status: 1 });
    } else if (check === false) {
      setInput({ ...input, job_status: 0 });
    }
  };

  const handleChangeFilter = (event) => {
    setFilter({ ...filter, [event.target.name]: event.target.value });
  };

  const handleChangeSearch = (event) => setSearch(event.target.value);

  const handleSubmit = (event) => {
    event.preventDefault();

    let {
      title,
      job_description,
      job_qualification,
      job_type,
      job_tenure,
      job_status,
      company_name,
      company_image_url,
      company_city,
      salary_min,
      salary_max,
    } = input;

    if (currentId === -1) {
      axios
        .post(
          `https://dev-example.sanbercloud.com/api/job-vacancy`,
          {
            title,
            job_description,
            job_qualification,
            job_type,
            job_tenure,
            job_status,
            company_name,
            company_image_url,
            company_city,
            salary_min,
            salary_max,
          },
          {
            headers: { Authorization: "Bearer " + Cookies.get("token") },
          }
        )
        .then((res) => {
          console.log(res);
          setFetchStatus(true);
          navigate("/dashboard/list-job-vacancy");
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      axios
        .put(
          `https://dev-example.sanbercloud.com/api/job-vacancy/${currentId}`,
          {
            title,
            job_description,
            job_qualification,
            job_type,
            job_tenure,
            job_status,
            company_name,
            company_image_url,
            company_city,
            salary_min,
            salary_max,
          },
          {
            headers: { Authorization: "Bearer " + Cookies.get("token") },
          }
        )
        .then((res) => {
          console.log(res);
          setFetchStatus(true);
          navigate("/dashboard/list-job-vacancy");
        })
        .catch((err) => {
          console.log(err);
        });
    }
    console.log(currentId);

    //indikator id jadi -1 lagi
    setCurrentId(-1);

    //kosongin input lagi
    setInput({
      title: "",
      job_description: "",
      job_qualification: "",
      job_type: "",
      job_tenure: "",
      job_status: 0,
      company_name: "",
      company_image_url: "",
      company_city: "",
      salary_min: 0,
      salary_max: 0,
    });
  };

  let state = {
    data,
    setData,
    fetchStatus,
    setFetchStatus,
    currentId,
    setCurrentId,
    checked,
    setChecked,
    input,
    setInput,
    search,
    setSearch,
    filter,
    setFilter,
  };
  let handleFunction = {
    handleEdit,
    handleDetail,
    handleDelete,
    handleText,
    handleInput,
    handleCheckbox,
    handleChecked,
    handleSubmit,
    handleChangeSearch,
    handleChangeFilter,
  };

  return (
    <GlobalContext.Provider value={{ state, handleFunction }}>
      {props.children}
    </GlobalContext.Provider>
  );
};
